// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-full {
    background-color: gray;
    padding-bottom: 60px;
}

.team-header {
    margin-top: 20px;
    text-align: left;
}

@media (max-width: 992px) {
    .team-header {
        text-align: center;
    }
}

.team-row {
    padding-top: 50px;
    padding-bottom: 10px;
}

.team-member {
    height: auto;
    margin: 10px;
    padding: 30px;
}

.team-member h4 {
    margin-top: 0;
}

.team-member__image-wrapper {
    margin-bottom: 20px;
}

.team-member__image {
    height: 20vh;
    width: auto;
    border-radius: 15px;
}

.team-member__name,
.team-member__title,
.team-member__description,
.team-member__link {
    text-align: left;
    margin-top: 0;
}

.team-member__title {
    margin-top: -15px;
}

.team-member__description {
    max-width: 300px;
}

.team-member__link {
    margin-top: 20px;
}

@media (max-width: 991px) {
    .team-member__image-wrapper,
    .team-member__name,
    .team-member__title,
    .team-member__link {
        text-align: center;
        display: block;
    }

    .team-member__description {
        margin: 0 auto;
        text-align: justify;
        display: block;
    }

    .team-member {
        padding-inline: 0;
    }


    .team-member__image-wrapper {
        margin-inline: auto;
    }

}
`, "",{"version":3,"sources":["webpack://./src/components/team/TeamFull.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;;;;IAII,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;;;;QAII,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;;IAGA;QACI,mBAAmB;IACvB;;AAEJ","sourcesContent":[".team-full {\n    background-color: gray;\n    padding-bottom: 60px;\n}\n\n.team-header {\n    margin-top: 20px;\n    text-align: left;\n}\n\n@media (max-width: 992px) {\n    .team-header {\n        text-align: center;\n    }\n}\n\n.team-row {\n    padding-top: 50px;\n    padding-bottom: 10px;\n}\n\n.team-member {\n    height: auto;\n    margin: 10px;\n    padding: 30px;\n}\n\n.team-member h4 {\n    margin-top: 0;\n}\n\n.team-member__image-wrapper {\n    margin-bottom: 20px;\n}\n\n.team-member__image {\n    height: 20vh;\n    width: auto;\n    border-radius: 15px;\n}\n\n.team-member__name,\n.team-member__title,\n.team-member__description,\n.team-member__link {\n    text-align: left;\n    margin-top: 0;\n}\n\n.team-member__title {\n    margin-top: -15px;\n}\n\n.team-member__description {\n    max-width: 300px;\n}\n\n.team-member__link {\n    margin-top: 20px;\n}\n\n@media (max-width: 991px) {\n    .team-member__image-wrapper,\n    .team-member__name,\n    .team-member__title,\n    .team-member__link {\n        text-align: center;\n        display: block;\n    }\n\n    .team-member__description {\n        margin: 0 auto;\n        text-align: justify;\n        display: block;\n    }\n\n    .team-member {\n        padding-inline: 0;\n    }\n\n\n    .team-member__image-wrapper {\n        margin-inline: auto;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
